import React, { useContext } from 'react';
import { MapWidgetEventsStore } from './store';

export const EventsContext = React.createContext<
  MapWidgetEventsStore | undefined
>(undefined);

export const useEventsContext = (): MapWidgetEventsStore => {
  const value = useContext(EventsContext);

  if (value) return value;

  throw new Error(
    'Не удалось получить значение контекста EventsContext. Контекст не был инициализирован перед обращением',
  );
};
